import React, { useState, useEffect, useRef } from 'react';
import { Button, Tab, Tabs } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { AddCircleRounded } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {
  POST_CHECKIN_UI_BUILDER_MOBILE_MENU,
  PRE_CHECKIN_UI_BUILDER_MOBILE_MENU,
  UIBUILDER_MENU_DISCOVER,
  UIBUILDER_MENU_HAMBURGER,
} from '../../../../constants/UiBuilderConst';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import AddMenuModal from './discover/Add-Menu-Modal';
import {
  fetchAllUIBuilderMenu,
  selectedHotelSelector,
  uiBuilderMenuListSelector,
  uiBuilderMenuLoaderSelector,
  setAllUIBuilderMenu,
  setAllUIBuilderHamburgerMenu,
  uiBuilderHamburgerMenuListSelector,
  fetchAllUIBuilderHamburgerMenu,
} from '../../../property/propertySlice';
import MenuListTable from './discover/Menu-List-Table';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  changeHamburgerMenuItemState,
  deleteUIBuilderHamburgerMenu,
  deleteUIBuilderMenu,
  reorderUIBuilderMenu,
} from '../../../../utils/UiBuilderAPIUtils';
import AddHamburgerMenuModal from './hamburger-menu/Add-Menu-Modal';
import HamburgerMenuListTable from './hamburger-menu/Menu-List-Table';
import { SaveButton } from '../../../../shared/custom-dragdrop/Save-Button';
import { createDataSortMapping } from '../../../../utils/PropertyAPIUtils';
import useOutsideAlerter from '../../../../custom-hooks/useOutsideAlerter';
import DeactivationPopupModel from '../../../../shared/deactivation-popup/Deactivation-Popup';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    margin: '5px !important',
    borderRadius: '5px !important',
    borderBottom: '4px solid #74E287',
    opacity: 1,
    minWidth: '100px',
    fontWeight: 500,
    fontSize: '16px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  button: {
    border: '1px solid #999999',
    margin: '5px !important',
    borderRadius: '5px !important',
    minWidth: '100px',
    fontWeight: 500,
    fontSize: '16px',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  input: {
    display: 'none',
  },
}));

const UiBuilderMenuList = (props) => {
  const { showLoader = () => {} } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedHotel = useSelector(selectedHotelSelector);
  const uiBuilderMenuLoader = useSelector(uiBuilderMenuLoaderSelector);
  const uiBuilderMenuList = useSelector(uiBuilderMenuListSelector);
  const uiBuilderHamburgerMenuList = useSelector(uiBuilderHamburgerMenuListSelector);
  const [activeTab, setActiveTab] = useState(UIBUILDER_MENU_DISCOVER);
  const [toggleAddMenuPopup, setToggleAddMenuPopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    menu: null,
  });
  const [tabValue, setTabValue] = useState(0);
  const [hamburgerAddModal, setHamburgerAddModal] = useState(false);
  const [preCheckInList, setPreCheckInList] = useState(null);
  const [postCheckInList, setPostCheckInList] = useState(null);
  const [visible, setVisible] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setPreCheckInList(uiBuilderHamburgerMenuList?.pre);
    setPostCheckInList(uiBuilderHamburgerMenuList?.post);
  }, [uiBuilderHamburgerMenuList]);

  const toggleModal = () => {
    if (toggleAddMenuPopup) handleClose();
    setToggleAddMenuPopup(!toggleAddMenuPopup);
  };

  const handleMenuClick = (event, currMenu) => {
    setSelectedValue({
      id: currMenu.id,
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: event.currentTarget,
      menu: currMenu,
    });
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      isActive: false,
      anchorEl: null,
      menu: null,
    });
  };

  const handleEdit = (e, currMenu) => {
    setSelectedValue({
      id: currMenu.id,
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      menu: currMenu,
    });
    toggleModal();
  };

  const handleRemove = (e, currMenu) => {
    setSelectedValue({
      id: currMenu.id,
      name: currMenu.name,
      title: 'Are you sure you want to delete',
      description: 'This action cannot be reversed',
      status: true,
      anchorEl: null,
      menu: currMenu,
    });
  };

  const handleDeactivate = (e, currMenu) => {
    setSelectedValue({
      id: currMenu.id,
      name: currMenu.name,
      title: 'Are you sure you want to deactivate',
      status: false,
      isActive: true,
      anchorEl: null,
      menu: currMenu,
    });
  };

  const onDelete = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      await deleteUIBuilderMenu(selectedValue?.id, selectedHotel, language);
      dispatch(fetchAllUIBuilderMenu(selectedHotel));
      handleClose();
      notificationManager('success', `Menu deleted successfully`);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : `Error occurred while deleting menu`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onDeleteCancel = () => {
    handleClose();
  };

  const onDeactivate = (e) => {
    onActiveDeActiveHamburgerMenu(e, 'deactivate');
  };

  const onDeactivateCancel = () => {
    handleClose();
  };

  const onReorderMenu = async (reorder) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const currentMenuList = [...uiBuilderMenuList];
      const [removed] = currentMenuList.splice(reorder.source.index, 1);
      currentMenuList.splice(reorder.destination.index, 0, removed);
      dispatch(setAllUIBuilderMenu(currentMenuList));
      await reorderUIBuilderMenu(selectedHotel, currentMenuList, language);
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : `Error occurred while reordering menu`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  //hamburger handlers
  const toggleHamburgerModal = () => {
    if (hamburgerAddModal) handleClose();
    setHamburgerAddModal(!hamburgerAddModal);
  };

  const handleHamburgerEdit = (e, currMenu) => {
    setSelectedValue({
      id: currMenu.id,
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      menu: currMenu,
    });
    toggleHamburgerModal();
  };

  const onHamburgerDelete = (e) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      deleteUIBuilderHamburgerMenu(selectedValue?.id, selectedHotel, language).then((res) => {
        dispatch(fetchAllUIBuilderHamburgerMenu(selectedHotel));
        notificationManager('success', `Menu deleted successfully`);
        handleClose();
      });
    } catch (error) {
      notificationManager('danger', `Error occurred while deleting menu`);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onActiveDeActiveHamburgerMenu = (e, type) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const payload = {
        hotelId: selectedHotel,
        id: selectedValue?.id,
        status: type === 'deactivate' ? false : true,
      };
      changeHamburgerMenuItemState(payload, language).then((res) => {
        dispatch(fetchAllUIBuilderHamburgerMenu(selectedHotel));
        notificationManager('success', `Menu item ${type}d successfully`);
        handleClose();
      });
    } catch (error) {
      notificationManager('danger', `Failed to ${type} menu item`);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  return (
    <div className='mt-4 mb-4 group-list-container ui-builder-menu'>
      {selectedValue?.id && selectedValue?.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}
      {selectedValue?.isActive && (
        <DeactivationPopupModel
          deactivationPopUp={selectedValue}
          onDeactivation={onDeactivate}
          onDeactivationCancel={onDeactivateCancel}
        />
      )}
      {toggleAddMenuPopup && (
        <AddMenuModal
          toggleAddMenuPopup={toggleAddMenuPopup}
          toggleModal={toggleModal}
          hotelId={selectedHotel}
          uiBuilderMenu={selectedValue.menu}
          showLoader={showLoader}
        />
      )}

      {selectedValue?.menu?.category && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={onHamburgerDelete}
          onDeleteCancel={onDeleteCancel}
        />
      )}

      {hamburgerAddModal && (
        <AddHamburgerMenuModal
          toggleAddMenuPopup={hamburgerAddModal}
          toggleModal={toggleHamburgerModal}
          hotelId={selectedHotel}
          uiBuilderMenu={selectedValue.menu}
          showLoader={showLoader}
        />
      )}

      <div className='col d-flex mt-4 guest-room-list mx-3 mb-3'>
        <div className='d-flex'>
          <Button
            size='large'
            variant={activeTab === UIBUILDER_MENU_DISCOVER ? 'outlined' : 'text'}
            className={
              activeTab === UIBUILDER_MENU_DISCOVER
                ? classes.activeButton
                : classes.button + 'showpopup'
            }
            onClick={() => setActiveTab(UIBUILDER_MENU_DISCOVER)}
          >
            {UIBUILDER_MENU_DISCOVER}
          </Button>
        </div>
        <div className='d-flex'>
          <Button
            size='large'
            variant={activeTab === UIBUILDER_MENU_HAMBURGER ? 'outlined' : 'text'}
            className={
              activeTab === UIBUILDER_MENU_HAMBURGER
                ? classes.activeButton
                : classes.button + 'showpopup'
            }
            onClick={() => setActiveTab(UIBUILDER_MENU_HAMBURGER)}
          >
            {UIBUILDER_MENU_HAMBURGER}
          </Button>
        </div>
        <div className='col-md-8 d-flex justify-content-end'>
          <SaveButton
            visible={visible}
            setVisible={setVisible}
            popUp={popUp}
            setPopUp={setPopUp}
            placeHolder={tabValue === 0 ? preCheckInList : postCheckInList}
            setPlaceHolder={tabValue === 0 ? setPreCheckInList : setPostCheckInList}
            globalPlaceHolder={uiBuilderHamburgerMenuList}
            setGlobalPlaceHolder={setAllUIBuilderHamburgerMenu}
            dispatch={dispatch}
            mappingApi={createDataSortMapping}
            displayText='Hamburger menu'
            module={
              tabValue === 0
                ? PRE_CHECKIN_UI_BUILDER_MOBILE_MENU
                : POST_CHECKIN_UI_BUILDER_MOBILE_MENU
            }
          />
        </div>
      </div>

      {activeTab === UIBUILDER_MENU_DISCOVER && (
        <div className='row add-button mx-3'>
          <div className='col-sm-2' onClick={() => toggleModal()}>
            <span className='span-add'>
              <AddCircleRounded className='add' />
              <span>Add New</span>
            </span>
          </div>
          {uiBuilderMenuLoader && (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          )}
          <MenuListTable
            handleMenuClick={handleMenuClick}
            selectedValue={selectedValue}
            uiBuilderMenuList={uiBuilderMenuList}
            handleClose={handleClose}
            handleEdit={handleEdit}
            handleRemove={handleRemove}
            onReorderMenu={onReorderMenu}
          />
        </div>
      )}

      {activeTab === UIBUILDER_MENU_HAMBURGER && (
        <div className='row add-button mx-3'>
          <Tabs
            value={tabValue}
            indicatorColor='primary'
            onChange={handleTabChange}
            aria-label='hotel-add-tabs'
            textColor='primary'
            className='property-tabs'
          >
            <Tab label='Pre Check-in' className={`${tabValue === 1 && 'showpopup'}`} />
            <Tab label='Post Check-in' className={`${tabValue === 0 && 'showpopup'}`} />
          </Tabs>
          <div className='col-sm-2 mt-3 showpopup' onClick={() => toggleHamburgerModal()}>
            <span className='span-add showpopup'>
              <AddCircleRounded className='add showpopup' />
              <span className='showpopup'>Add New</span>
            </span>
          </div>
          {uiBuilderMenuLoader && (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          )}
          <div ref={wrapperRef} className='col-12'>
            <HamburgerMenuListTable
              handleMenuClick={handleMenuClick}
              selectedValue={selectedValue}
              list={tabValue === 0 ? preCheckInList : postCheckInList}
              setList={tabValue === 0 ? setPreCheckInList : setPostCheckInList}
              setVisible={setVisible}
              handleClose={handleClose}
              handleEdit={handleHamburgerEdit}
              handleRemove={handleRemove}
              handleDeactivate={handleDeactivate}
              onActiveDeActiveHamburgerMenu={onActiveDeActiveHamburgerMenu}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UiBuilderMenuList;
